import useGetReservationsByServiceId from '@/hooks/queries/reservations-api/useGetReservationByServiceId';
import useGetOrganizationServices from '@/hooks/queries/services-api/useGetOrganizationServices';
import { TServices } from '@/services/services';
import { useMemo, useState } from 'react';

const useAttendanceData = () => {
  const [valueFilter, setValueFilter] = useState<string | undefined>();
  const today = useMemo(() => new Date(), []);
  const { data: services, isLoading: isLoadingServices } =
    useGetOrganizationServices<TServices[]>();
  const SERVICE_ID = services?.find((item) => item.enabled)?.id ?? null;
  const { data, isLoading: isLoadingReservations } =
    useGetReservationsByServiceId({
      serviceId: SERVICE_ID,
      startDate: today,
      endDate: today
    });
  const reservations = valueFilter
    ? data?.filter(
        (item) => item.consumers[0]?.additionalData?.group === valueFilter
      )
    : data;

  return {
    services,
    reservations,
    isLoading: isLoadingServices || isLoadingReservations,
    valueFilter,
    setValueFilter
  };
};

export default useAttendanceData;
